import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveProductRecipeLinkingRequestInput } from './SaveProductRecipeLinkingRequestInput';
import { SaveProductRecipeLinkingRequestOutput } from './SaveProductRecipeLinkingRequestOutput';

export class SaveProductRecipeLinkingRequestService extends HttpServiceBase {

  handle = (input: SaveProductRecipeLinkingRequestInput): Promise<Result<SaveProductRecipeLinkingRequestOutput> | null> => {
    const promise = this.http.post<Result<SaveProductRecipeLinkingRequestOutput>, SaveProductRecipeLinkingRequestInput>(
      `${this.baseUrlSislogApi}/v2/recipe-by-product/linking-request`, input);
    return promise;
  }
}